export default "__VITE_ASSET__BAUIE0Pq__"